import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Editar from './Editar'

const route = {
  path: '/ocorrencias',
  name: 'ocorrencias',
  component: Index,
  children: [
    { path: 'listar', name: 'ocorrencias-listar', component: Listar, props: { titulo: 'Listar', status: null } },
    { path: 'listar-aguardando-atendimento', name: 'ocorrencias-listar-aguardando-atendimento', component: Listar, props: { titulo: 'Listar Aguardando Atendimento', status: 1 } },
    { path: 'listar-em-atendimento', name: 'ocorrencias-listar-em-atendimento', component: Listar, props: { titulo: 'Listar Em Atendimento', status: 2 } },
    { path: 'listar-pendentes', name: 'ocorrencias-listar-pendentes', component: Listar, props: { titulo: 'Listar Pendentes', status: 3 } },
    { path: 'listar-concluidos', name: 'ocorrencias-listar-concluidos', component: Listar, props: { titulo: 'Listar Concluídos', status: 4 } },
    { path: 'listar-cancelados', name: 'ocorrencias-listar-cancelados', component: Listar, props: { titulo: 'Listar Cancelados', status: 8 } },
    { path: ':id', name: 'ocorrencias-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'ocorrencias-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/ocorrencias/routes.js